import { StockAvailability, ProductOrderField, ReviewSortField, OrderDirection } from '__generated__/globalTypes';
import { normalizeToDBIds } from "@utils";

export const DEFAULT_APP_LINK = 'https://maccaron.app.link/';

export const APP_STORE_URL =
  'https://apps.apple.com/us/app/maccaron/id1545087223?utm_source=footer&utm_medium=Appstore';

export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=in.maccaron&utm_source=footer&utm_medium=Googleplay';

export const DESKTOP_PRODUCT_LIST_REQUEST_COUNT = 10;

export const MOBILE_PRODUCT_LIST_REQUEST_COUNT = 8;

export const MAX_CART_LINE_QUANTITY = 5;

export const RESOLVE_ERROR_MESSAGE = "Couldn't resolve to a node";

// alert를 띄우고 싶지 않은 에러 메시지 목록
export const IGNORE_GRAPHQL_ERROR_MESSAGES = ['', 'Pincode matching query does not exist.', 'User has no wishlist.'];

export const NEED_SESSION_ERROR_MESSAGE = 'You do not have permission to perform this action';

export const OAUTH_LOGIN_EMPTY_EMAIL_ALERT_MESSAGE =
  'Encounter issues retrieving email address. Check your social media privacy settings or Try a different login method';

export const COM_DESKTOP_PRODUCTS_FILTER_OPTIONS = [
  {
    title: 'Stock',
    name: 'stockAvailability',
    options: [
      { title: 'In Stock', value: StockAvailability.IN_STOCK },
      { title: 'All', value: '' },
    ],
  },
];

export const DESKTOP_PRODUCTS_FILTER_OPTIONS = [
  {
    title: 'Stock',
    name: 'stockAvailability',
    options: [
      { title: 'In Stock', value: StockAvailability.IN_STOCK },
      { title: 'All', value: '' },
    ],
  },
  {
    title: 'Product Type',
    name: 'isMgs',
    options: [
      { title: 'All', value: '' },
      { title: 'Maccaron Only', value: false },
      { title: 'MGS Only', value: true },
    ],
  },
];

export const COM_MOBILE_PRODUCTS_FILTER_OPTIONS = [
  {
    title: 'Stock',
    name: 'stockAvailability',
    options: [
      { title: 'In Stock', value: StockAvailability.IN_STOCK },
      { title: 'All', value: null },
    ],
  },
];

export const MOBILE_PRODUCTS_FILTER_OPTIONS = [
  {
    title: 'Stock',
    name: 'stockAvailability',
    options: [
      { title: 'In Stock', value: StockAvailability.IN_STOCK },
      { title: 'All', value: null },
    ],
  },
  {
    title: 'Product Type',
    name: 'isMgs',
    options: [
      { title: 'All', value: '' },
      { title: 'Maccaron Only', value: false },
      { title: 'MGS Only', value: true },
    ],
  },
];

export const PRODUCTS_SORTING_FILTER_OPTIONS = [
  { label: 'Popularity', value: { field: ProductOrderField.POPULARITY, direction: OrderDirection.DESC } },
  { label: 'Newest', value: { field: ProductOrderField.DATE, direction: OrderDirection.DESC } },
  { label: 'Lowest Price', value: { field: ProductOrderField.PRICE, direction: OrderDirection.ASC } },
  { label: 'Highest Price', value: { field: ProductOrderField.PRICE, direction: OrderDirection.DESC } },
  { label: 'Highest Review Rank', value: { field: ProductOrderField.REVIEW_RATING, direction: OrderDirection.DESC } },
  { label: 'Alphabetically | A - Z', value: { field: ProductOrderField.NAME, direction: OrderDirection.ASC } },
  { label: 'Alphabetically | Z - A', value: { field: ProductOrderField.NAME, direction: OrderDirection.DESC } },
];

export const REVIEWS_FILTER_OPTIONS = [
  {
    title: 'Filter',
    name: 'hasImage',
    options: [
      { title: 'All', value: null },
      { title: 'Photo', value: true },
    ],
  },
];

export const REVIEWS_SORTING_FILTER_OPTIONS = [
  { label: 'Newest', value: { field: ReviewSortField.CREATE_AT, direction: OrderDirection.DESC } },
  { label: 'Highest Rating', value: { field: ReviewSortField.RATING, direction: OrderDirection.DESC } },
  { label: 'Lowest Rating', value: { field: ReviewSortField.RATING, direction: OrderDirection.ASC } },
  { label: 'Most Votes', value: { field: ReviewSortField.TOTAL_VOTES, direction: OrderDirection.DESC } },
];

export const PLACEHOLDER_IMAGE_URL = '/static/images/placeholder';

// TODO: 정규표현식 정리
export const DO_NOT_ALLOW_CONSECUTIVE_SPACE = /\s+/g;
export const ADDRESS_NICKNAME_REGEX_MAX_LENGTH = 15;
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const MOBILE_NUMBER_REGEX = /^(?!9999999999)[6-9]\d{9}$/;
export const OTP_REGEX = /^\d{6}$/;
export const PIN_CODE_REGEX = /^\d{6}$/;
export const ALPHABET_ONLY_REGEX = /^[a-zA-Z\s]+$/;
export const ADDRESS_NICKNAME_REGEX = /^[a-zA-Z0-9\s\-_]+$/;
export const STREET_ADDRESS_REGEX = /^[a-zA-Z0-9\-,.()/\s]+$/i;

// 허용하지 않는 값 체크용 정규식
export const DISALLOWED_ALPHABET_ONLY_REGEX = /[^a-zA-Z\s]/g;
export const DISALLOWED_ADDRESS_NICKNAME_REGEX = /[^a-zA-Z0-9\s\-_]/g;
export const DISALLOWED_STREET_ADDRESS_REGEX = /[^a-zA-Z0-9\s.,()/-]/g;
export const DISALLOWED_NUMBER_REGEX = /\D/g;

// TODO: color 정리
export const SKELETON_COLOR = '#0724400A';

// OTP verify Message
export const WRONG_OTP_MESSAGE = 'OTP not verified! Check the numbers again.';
export const CORRECT_OTP_MESSAGE = 'OTP Verified!';
export const SIGN_UP_COMPLETE_MESSAGE = 'Sign up completed! 🎉';

export const BEAUTY_DEVICE_PRODUCT_IDS = [
  '24585',
  '95251',
  '24587',
  '24588',
  '24586',
  '79547',
  '79543',
  '79555',
  '79535',
  '79533',
];

let dynamicInvisibleIds: string[] = [];

export const INVISIBLE_PRODUCT_IDS = ['942', '950', '12537'];

export function setDynamicInvisibleIds(ids: string[]) {
  dynamicInvisibleIds = ids;
}

export function getInvisibleProductIds(): string[] {
  return normalizeToDBIds([...INVISIBLE_PRODUCT_IDS, ...dynamicInvisibleIds], 'Product');
}

let dynamicInvisibleBrandIds: string[] = [];

export const INVISIBLE_BRAND_IDS = [];

export function setDynamicInvisibleBrandIds(ids: string[]) {
  dynamicInvisibleBrandIds = ids;
}

export function getInvisibleBrandIds(): string[] {
  return normalizeToDBIds([...INVISIBLE_BRAND_IDS, ...dynamicInvisibleBrandIds], 'Brand');
}

export const HIDE_VOUCHER_BRAND_IDS = ['229', '12'];

// Country Area
export const COUNTRY_AREA_LIST = [
  { name: 'Andhra Pradesh', value: 'Andhra Pradesh' },
  { name: 'Andaman & Nicobar', value: 'Andaman & Nicobar' },
  { name: 'Arunachal Pradesh', value: 'Arunachal Pradesh' },
  { name: 'Assam', value: 'Assam' },
  { name: 'Bihar', value: 'Bihar' },
  { name: 'Chandigarh', value: 'Chandigarh' },
  { name: 'Chhattisgarh', value: 'Chhattisgarh' },
  { name: 'Dadra and Nagar Haveli', value: 'Dadra and Nagar Haveli' },
  { name: 'Daman and Diu', value: 'Daman and Diu' },
  { name: 'Delhi', value: 'Delhi' },
  { name: 'Goa', value: 'Goa' },
  { name: 'Gujarat', value: 'Gujarat' },
  { name: 'Haryana', value: 'Haryana' },
  { name: 'Himachal Pradesh', value: 'Himachal Pradesh' },
  { name: 'Jammu and Kashmir', value: 'Jammu and Kashmir' },
  { name: 'Jharkhand', value: 'Jharkhand' },
  { name: 'Karnataka', value: 'Karnataka' },
  { name: 'Kerala', value: 'Kerala' },
  { name: 'Lakshadweep', value: 'Lakshadweep' },
  { name: 'Madhya Pradesh', value: 'Madhya Pradesh' },
  { name: 'Maharashtra', value: 'Maharashtra' },
  { name: 'Manipur', value: 'Manipur' },
  { name: 'Meghalaya', value: 'Meghalaya' },
  { name: 'Mizoram', value: 'Mizoram' },
  { name: 'Nagaland', value: 'Nagaland' },
  { name: 'Odisha', value: 'Odisha' },
  { name: 'Puducherry', value: 'Puducherry' },
  { name: 'Punjab', value: 'Punjab' },
  { name: 'Rajasthan', value: 'Rajasthan' },
  { name: 'Sikkim', value: 'Sikkim' },
  { name: 'Tamil Nadu', value: 'Tamil Nadu' },
  { name: 'Telangana', value: 'Telangana' },
  { name: 'Tripura', value: 'Tripura' },
  { name: 'Uttar Pradesh', value: 'Uttar Pradesh' },
  { name: 'Uttarakhand', value: 'Uttarakhand' },
  { name: 'West Bengal', value: 'West Bengal' },
];
